<app-entity-mat-dialog-title title="What's New"></app-entity-mat-dialog-title>

<div mat-dialog-content>
  <p class="text-muted">Recent updates to Agenda Master.</p>
  <app-whats-new-list></app-whats-new-list>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" mat-dialog-close type="button">Close</button>
</mat-dialog-actions>
